import NumberFormatter from './NumberFormatter.js';

/**
 * Innings pitched (IP) are the number of innings a pitcher has completed, measured by the number of batters and baserunners that are put out while the pitcher is in the game.
 * Three outs made is equal to one inning pitched. One out counts as one-third of an inning, and two outs counts as two-thirds of an inning.
 * Sometimes, the statistic is written 34.1, 72.2, or 91.0, for example, to represent 34 and 1/3 innings, 72 and 2/3 innings, and 91 innings exactly, respectively.
 * This formatter returns .1 .2 .0 rounding which is kinda unique to IP stat
 * @see https://baseball.fandom.com/wiki/Innings_pitched
 */
class InningsPitchedFormatter extends NumberFormatter {
    constructor(fallback) {
        super(1, fallback);
    }

    format(value) {
        if (typeof(value) !== 'number') {
            return this.fallback;
        }

        if (!Number.isNaN(value) && typeof(value) === 'number') {
            const outsPitched = Math.round(value * 3);
            const moduloThree = outsPitched % 3;

            // 34.1 to represent 34 and 1/3 innings
            // 72.2 to represent 72 and 2/3 innings
            // 91.0 to represent 91 innings exactly
            return Math.floor(value) + (moduloThree / 10);
        }

        return this.fallback;
    }
}

export default InningsPitchedFormatter;